import React from "react";

const CodigoGeograficoParticular = (props) => {
    const { data, domicilio, guardarCampo, novedadCodigoGeografico, CodGeoPartSeleccionado } = props;//reciben(extrae) las propiedades con el mismo nombre.
    // const { Validaciones, ValidarPantalla } = data;//(extrae) las propiedades con el mismo nombre del objeto data ya creado anteriormente

    let seleccionado = novedadCodigoGeografico != undefined ? CodGeoPartSeleccionado != undefined ? CodGeoPartSeleccionado : "0" : CodGeoPartSeleccionado != undefined ? CodGeoPartSeleccionado : undefined;
    const codigoGeografico = seleccionado != undefined ? seleccionado : data.DomicilioParticularCodigoGeografico;

    //let inputGeo = novedadCodigoGeografico != undefined ? novedadCodigoGeografico : undefined;
    //data.DomicilioParticularCodigoGeograficoInput =  inputGeo != undefined ? inputGeo : data.DomicilioParticularCodigoGeograficoInput;
    //const codigoGeografico = data.DomicilioParticularCodigoGeograficoInput != undefined ||
    //    data.DomicilioParticularCodigoGeograficoInput != "" ?
    //    data.DomicilioCorrespondenciaCodigoGeografico : "0";

    data.DomicilioParticularCodigoGeograficoInput = novedadCodigoGeografico != undefined &&
        data.DomicilioParticularCodigoGeograficoInput == undefined ?
        novedadCodigoGeografico :
        data.DomicilioParticularCodigoGeograficoInput;


    const desactivarInput = (codigoGeografico != "0");
    const me = this;

    let radioCodigoGeo = null;
    let codigos;

    if (data.accountData.GET_CODIGO_GEOGRAFICO) {
        const codigoElements = data.accountData.GET_CODIGO_GEOGRAFICO.filter(c => c.CodigoPostal == domicilio.CodigoPostal);

        codigos = JSON.parse(JSON.stringify(codigoElements));
        codigos.push({ Id: 0, CodigoGeografico: "0" });


        radioCodigoGeo = codigos.map((codigo, index) => {
            const estaSeleccionado = (codigo.CodigoGeografico == codigoGeografico)

            if (codigo.CodigoGeografico == "0") {
                return (
                    <div className="col-xs-6" key={"div-codigo-geo-" + index}>
                        <div className="row">
                            <div className="col-xs-6">
                                <div className="container-radio radio-margin">
                                    <input value="0" type="radio" name="codigo-part-geografico"
                                        id={"codigo-part-geografico-" + index} checked={estaSeleccionado}
                                        onChange={() => { guardarCampo("0", "DomicilioParticularCodigoGeografico") }} />

                                    <label className="lbl-radio label-secondary" htmlFor={"codigo-part-geografico-" + index}>Otro</label>
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <input value={data.DomicilioParticularCodigoGeograficoInput} type="text"
                                    className="form-control default-input" maxLength="5" disabled={(desactivarInput)}
                                    onChange={(event) => { guardarCampo(event.target.value, "DomicilioParticularCodigoGeograficoInput") }} />
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="col-xs-3" key={"div-codigo-part-geo-" + index}>
                        <div className="container-radio radio-margin">
                            <input value={codigo.CodigoGeografico} type="radio" name="codigo-part-geografico"
                                id={"codigo-part-geografico-" + index} checked={estaSeleccionado}
                                onChange={(event) => { guardarCampo(event.target.value, "DomicilioParticularCodigoGeografico") }} />

                            <label className="lbl-radio label-secondary" htmlFor={"codigo-part-geografico-" + index}>{codigo.CodigoGeografico}</label>
                        </div>
                    </div>
                );
            }
        });
    }

    let mensajeError = null;
    //if (ValidarPantalla == true) {
    //    if (Validaciones.CodigoGeograficoSeleccionado == false) {
    //        mensajeError = <label className="error">Debe seleccionar un código geografico</label>;
    //    }
    //}

    return (
        <div>
            <div className="row">
                <div className="col-xs-12">
                    <h5>{"Código geográfico para " + domicilio.Localidad}</h5>
                </div>
            </div>
            <div className="row">
                {radioCodigoGeo}
                <div className="col-xs-12">
                    {mensajeError}
                </div>
            </div>
        </div>
    );
}

export default CodigoGeograficoParticular;